import React, { useState } from "react";
import { Menu, X, Heart } from "lucide-react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="nav">
      <div className="nav-inner">

        {/* Brand */}
        <Link to="/" className="brand">
          <div className="brand-icon"><Heart /></div>
          <span className="brand-title">Medico.in</span>
        </Link>

        {/* Desktop Navigation */}
        <div className="nav-links desktop-only">
          <Link to="/">Home</Link>
          <Link to="/about">About</Link>
          {/* <Link to="/ai">AI Assistant</Link> */}
          <Link to="/specs">Specs</Link>
          <Link to="/features">Features</Link>
          <Link to="/documentation">Docs</Link>
          <Link to="/team">Team</Link>
          <Link to="/contact">Contact</Link>
          <Link to="/help">Help</Link>
          <Link to="/project-report">Project Report</Link>

          {/* Updated with Link */}
          <Link to="/auth" className="btn btn-outline">Login</Link>
          <Link to="/auth" className="btn btn-primary">Register</Link>
        </div>

        {/* Mobile Menu Toggle */}
        <div className="mobile-only">
          <button
            className="icon-btn"
            aria-label="Toggle mobile menu"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <X /> : <Menu />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="mobile-menu"
        >
          <a href="#features" onClick={() => setIsOpen(false)}>Features</a>
          <a href="#how-it-works" onClick={() => setIsOpen(false)}>How it Works</a>
          <a href="#specs" onClick={() => setIsOpen(false)}>Specifications</a>

          {/* Updated with Link */}
          <div className="mobile-buttons">
            <Link
              to="/auth"
              className="btn btn-outline full"
              onClick={() => setIsOpen(false)}
            >
              Patient Login
            </Link>

            <Link
              to="/auth"
              className="btn btn-primary full"
              onClick={() => setIsOpen(false)}
            >
              Doctor Login
            </Link>
          </div>
        </motion.div>
      )}
    </nav>
  );
};

export default Navigation;
